import React, { useEffect, useState } from 'react';
import {Card,CardHeader,CardBody,Collapse } from 'reactstrap'
import { Button } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import EnumInput from '../misc/EnumInput';
import { RootState } from '../../store/store';
import { CorePasswordChangeInstanceSettings } from '../../models/CoreInstanceSettings';
import { EmptyRequestState, ErrorRequestState } from '../../models/RequestState';
import { getPasswordChangeRoleSettings, updatePasswordChangeRoleSettings } from '../../store/PasswordChangeSettingAction';
import StatusCode from '../../util/StatusCode';
import { PasswordChangeSettingRoleOptions } from '../../models/CorePasswordChangeModels'
import { CorePasswordAdminAccountRole} from '../../models/CorePasswordAdminModels'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Loading from '../misc/Loading';
import CoreApiError from '../misc/CoreApiError'; 
interface PasswordChangeRoleSettingProps {
    disabled?: boolean
}

const PasswordChangeRoleSetting: React.FC<PasswordChangeRoleSettingProps> = ({ disabled }) => {
    const { t } = useTranslation(['common', 'configuration']);
    const dispatch = useDispatch();

    const settings = useSelector<RootState, CorePasswordChangeInstanceSettings | undefined>(x => x.passwordChangeSetting.settings); 
    const updateStatus = useSelector<RootState, EmptyRequestState>(x => x.passwordChangeSetting.updateStatus);

    const [selectedRole, setSelectedRole] = useState<number>(CorePasswordAdminAccountRole.STAFF);
    const [isOpen, setIsOpen] = useState<boolean>(true);

    useEffect(() => {
        if (settings === undefined) {
            getPasswordChangeRoleSettings()(dispatch);
        }
    }, [dispatch, settings]);

    useEffect(() => {
        if (settings !== undefined) {
            setSelectedRole(settings.passwordChangeRoles);
        }
    }, [settings]);

    const save = async () => {
        if (settings === undefined || settings.passwordChangeRoles === selectedRole) {
            return;
        }

        await updatePasswordChangeRoleSettings({
            ...settings,
            passwordChangeRoles: selectedRole
        })(dispatch);

        getPasswordChangeRoleSettings()(dispatch);
    };

    const renderSaveStatus = () => {
        switch (updateStatus.code) {
            case StatusCode.PENDING:
                return <Loading />;
            case StatusCode.ERROR:
                return <CoreApiError requestState={updateStatus as ErrorRequestState} />;
            case StatusCode.COMPLETE:
                return <>
                    <FontAwesomeIcon icon="check" style={{ fontSize: '22px', verticalAlign: 'middle', color: '#27807d' }} />
                    <span style={{ marginLeft: '0.5rem' }}>{t('moduleView.saved', { ns: 'configuration' })}</span>
                </>;
            default:
                return null;
        }
    };

    return (
        <Card className="mb-3">
            <CardHeader tag="h2">
                <Button outline color="secondary" style={{ width: '37px', float: 'right' }} onClick={() => setIsOpen(!isOpen)}>{isOpen ? '-' : '+'}</Button>
                {t('passwordSetting.accessRole.title', { ns: 'common' })}
            </CardHeader>
            <Collapse isOpen={isOpen}>
                <CardBody> 
                    <EnumInput
                        title={t('passwordSetting.accessRole.type.title', { ns: 'common' })}
                        titleSmall={true}
                        multi={true}
                        name="passwordExportRole"
                        value={selectedRole}
                        onChange={(_, value) => setSelectedRole(value)}
                        options={PasswordChangeSettingRoleOptions.map(x => ({
                            value: x,
                            text: t(`passwordSetting.accessRole.type.${x}`, { ns: 'common' }),
                        }))}
                        disabled={disabled}
                    />

                    <Button
                        disabled={disabled || settings === undefined || settings.passwordChangeRoles === selectedRole || updateStatus.code === StatusCode.PENDING}
                        onClick={save}>
                    {t('action.save', { ns: 'common' })}
                    </Button>

                    <div style={{ marginLeft: '1rem', display: 'inline-block' }}>
                        {renderSaveStatus()}
                    </div>
                </CardBody>
            </Collapse>
        </Card>
    );
};

export default PasswordChangeRoleSetting;